import { css } from '@firebolt-dev/css'
import { useEffect, useRef, useState } from 'react'

import { Client } from '../Client'
import { storage } from '../utils'
import { GameUI } from './GameUI'
import { GameFrames } from './GameFrames'
import { Toasts } from './Toasts'
import { Stats } from './Stats'
import { Editor } from './Editor'

export function GameContent({ setDisconnected }) {
  const containerRef = useRef()
  const viewportRef = useRef()
  const [world, setWorld] = useState(null)
  const [statsVisible, setStatsVisible] = useState(() => storage.get('statsVisible') ?? false)

  useEffect(() => {
    const viewport = viewportRef.current
    const world = new Client(viewport)
    world.on('disconnect', () => {
      setDisconnected(true)
    })
    world.on('toggleStats', () => setStatsVisible(v => {
      storage.set('statsVisible', !v)
      return !v
    }))
    setWorld(world)
    return () => {
      // ...
    }
  }, [])

  return (
    <div
      ref={containerRef}
      className='game'
      css={css`
        position: absolute;
        inset: 0;
        .game-viewport {
          width: 100%;
          height: 100%;
        }
        .game-center {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 4px;
          height: 4px;
          background: red;
        }
      `}
    >
      <div className='game-viewport' ref={viewportRef} />
      {world && (
        <>
          <GameFrames world={world} />
          <GameUI world={world} />
          <Toasts world={world} />
          {statsVisible && <Stats world={world} />}
          <Editor world={world} />
        </>
      )}
    </div>
  )
}
